import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const PackageServices = {

    allPackages : async (data) =>{
        console.log('Received parameters data:',data);

        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/lyns-packages/list?${queryParams.toString()}`,{}, Helpers.token());
    },

    addPackage : async (data) =>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/lyns-packages/create`,data, Helpers.token());
    },

    updatePackage : async (data,id) =>{
        return await commonRequest("PUT",  `${Helpers.URL()}/api/admin/lyns-packages/update/${id}`, data, Helpers.token());
    },
    deletePackage : async (id) =>{
        return await commonRequest("DELETE",  `${Helpers.URL()}/api/admin/lyns-packages/delete/${id}`, {}, Helpers.token());
    },
    restorePackage : async (id) =>{
        return await commonRequest("PUT",  `${Helpers.URL()}/api/admin/lyns-packages/restore/${id}`, {}, Helpers.token());
    },
}
